import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MobileAppLinkingConfigWizardScene = lazy(() =>
  import("@scenes/UniversalLinks/components/MobileAppLinkingConfigWizard").then((module) => ({
    default: module.MobileAppLinkingConfigWizardScene,
  }))
);

export const mobileAppLinkingConfigWizardNRO: NavigationRoutingObject = {
  section: "settings",
  Component: MobileAppLinkingConfigWizardScene,
  heading: (t: I18nT<"dashboard-navigation">) => t("universal-links-nro-heading", "Universal Links"),
  pageNameForTracking: () => "Universal Links Create",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  getDeveloperNavigationAllowed: ({ hasPermission, featureOn }) => {
    if (!featureOn("verified_domain")) {
      return false;
    }
    return hasPermission("company", { permission: "editDomainSettings" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/verified_domains/:appGroupId",
};
